<div class="d-flex flex-column align-items-center">
  <object class="mb-4" data="../../../../assets/icons/not_found_result.svg" type="image/svg+xml"></object>
  <h1 class="mb-2">{{ titleMSG }}</h1>
  <p>{{ subtitleMSG }}</p>
</div>
